import React from "react";
import "./Icon.css";

export interface IconProps extends Omit<React.SVGProps<SVGSVGElement>, "ref"> {
  /** Icon component from @untitledui/icons */
  icon: React.ComponentType<any>;
  /** Size variant based on design tokens */
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  /** Color variant */
  variant?: "default" | "muted" | "accent" | "success" | "warning" | "error" | "clinical";
  /** Custom stroke width */
  strokeWidth?: number;
}

const sizeMap = {
  xs: "12px",
  sm: "16px",
  md: "20px",
  lg: "24px",
  xl: "32px",
  "2xl": "40px",
};

export const Icon: React.FC<IconProps> = ({
  icon: IconComponent,
  size = "md",
  variant = "default",
  strokeWidth = 2,
  className = "",
  ...props
}) => {
  const iconSize = sizeMap[size];

  // Return a placeholder if IconComponent is invalid to avoid crash
  if (!IconComponent || typeof IconComponent !== 'function') {
    // Return a placeholder to avoid crash
    return (
      <span
        className={`icon icon--error ${className}`}
        style={{ width: iconSize, height: iconSize, display: 'inline-block', backgroundColor: 'red' }}
        title="Icon Error: IconComponent is undefined"
      />
    );
  }

  return (
    <IconComponent
      className={`icon icon--${variant} ${className}`}
      style={{ width: iconSize, height: iconSize }}
      strokeWidth={strokeWidth}
      aria-hidden="true"
      {...props}
    />
  );
};